module.exports = __webpack_public_path__ + "img/christophe-fazilleau.7b5be766.png";